import config from "../config";

const API = config.apiUrl;

async function request(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || "Request failed");
  }
  return res.json();
}

export const eventsApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/events${qs ? `?${qs}` : ""}`);
  },
  get: (id) => request(`/events/${id}`),
};

export const inquiriesApi = {
  submit: (data) =>
    request("/inquiries", { method: "POST", body: JSON.stringify(data) }),
};
